<button
  mat-icon-button
  [color]="hasValue ? 'primary' : undefined"
  #menuTrigger="matMenuTrigger"
  [matMenuTriggerFor]="menu"
  (click)="$event.stopPropagation()"
  (menuOpened)="onMenuOpen()"
>
  <mat-icon>filter_list</mat-icon>
</button>
<mat-menu #menu="matMenu">
  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="filter-menu" (click)="$event.stopPropagation()">
    <div>Filter by {{ column.name }}</div>
    <div [ngSwitch]="column.type">
      <div *ngSwitchCase="'text'">
        <app-boomer-text-input
          [label]="column.name"
          [form]="form"
          formControlName="value"
          #firstInput
        ></app-boomer-text-input>
      </div>
      <div *ngSwitchCase="'number'">
        <app-boomer-number-input
          [label]="column.name"
          [form]="form"
          formControlName="value"
          #firstInput
        ></app-boomer-number-input>
      </div>
      <ng-container *ngSwitchCase="'date'">
        <app-boomer-date-input label="From" [form]="form" formControlName="from" #firstInput></app-boomer-date-input>
        <app-boomer-date-input label="To" [form]="form" formControlName="to"></app-boomer-date-input>
      </ng-container>
      <ng-container *ngSwitchCase="'exact_datetime'">
        <mat-checkbox #oldPicker>Show Old Picker</mat-checkbox>
        @if (oldPicker.checked) {
          <app-boomer-date-input label="From" [form]="form" formControlName="from" #firstInput></app-boomer-date-input>
          <app-boomer-date-input label="To" [form]="form" formControlName="to"></app-boomer-date-input>
        } @else {
          <mat-form-field appearance="outline">
            <mat-label>From</mat-label>
            <input matInput type="datetime-local" formControlName="from" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>To</mat-label>
            <input matInput type="datetime-local" formControlName="to" />
          </mat-form-field>
        }
      </ng-container>
      <ng-container *ngSwitchCase="'select'" class="flex flex-col">
        <mat-radio-group class="mb-4 flex flex-col" formControlName="value">
          <mat-radio-button [value]="option.value" *ngFor="let option of column['options']" #firstInput>
            {{ option.label }}
          </mat-radio-button>
        </mat-radio-group>
      </ng-container>
      <ng-container *ngSwitchCase="'multi-select'" class="flex flex-col">
        <mat-form-field appearance="outline">
          <mat-label>{{ column.name }}</mat-label>
          <mat-select formControlName="value" multiple>
            <mat-option [value]="option.value" *ngFor="let option of column['options']">
              {{ option.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </ng-container>
      <ng-container *ngSwitchCase="'agent'">
        <app-boomer-agent-field label="Agent" [form]="form" formControlName="value"> </app-boomer-agent-field>
      </ng-container>
      <ng-container *ngSwitchCase="'boomer_user'">
        <app-boomer-boomer-user-field label="Broker User" [form]="form" formControlName="value">
        </app-boomer-boomer-user-field>
      </ng-container>
      <ng-container *ngSwitchDefault> Unsupported filter type: {{ column.type }} </ng-container>
    </div>
    <div class="flex flex-row justify-between gap-x-8">
      <button type="button" mat-raised-button (click)="clear()">Clear</button>

      <button type="submit" mat-raised-button color="primary">Search</button>
    </div>
  </form>
</mat-menu>
